<template>
  <div class="tuolele-main-box wechat-setting">
    <div class="color-black wechat-setting-title">
      当前微信授权状态
      <span class="color-blue" v-text="flag ? '已授权' : '未授权'" />
    </div>
    <div v-if="flag" class="wechat-info">
      <div class="wechat-info-item">
        <span class="wechat-info-item-label">开发者ID（App ID）</span>
        <div class="wechat-info-item-text">
          <div>{{ wechatInfo.authorizer_appid }}</div>
          <p>在微信公众平台，选择开发->基本配置->开发者ID(AppID)</p>
        </div>
      </div>
      <div class="wechat-info-item">
        <span class="wechat-info-item-label">开发者密码（AppSecret）</span>
        <div class="wechat-info-item-text">
          <div>{{ wechatInfo.authorizer_secret }}</div>
          <p>
            在微信公众平台，选择开发->基本配置->开发者密码（AppSecret）->启用
          </p>
        </div>
      </div>
      <div class="wechat-info-item">
        <span class="wechat-info-item-label">公众号唯一ID（原始ID）</span>
        <div class="wechat-info-item-text">
          <div>{{ wechatInfo.official_id }}</div>
          <p>在服务号，选择头像->账号详情->注册信息->原始ID</p>
        </div>
      </div>
      <div class="wechat-info-item">
        <span class="wechat-info-item-label">模版消息</span>
        <div class="wechat-info-item-text">
          <el-button type="primary" @click="setMessage">设置消息模板</el-button>
          <p>请先设置好 “微信公众号-模版消息-类目模版库-服务类目”</p>
        </div>
      </div>

      <div class="wechat-info-item">
        <span class="wechat-info-item-label">学员中心（菜单链接）</span>
        <div class="wechat-info-item-text">
          <div>微信公众号“自定义菜单”使用</div>
        </div>
          <el-input
          v-model="wechatInfo.myurl"
          type="textarea"
          resize="none"
          :autosize="{ minRows: 5 }"
        />
      </div>
      <div class="wechat-info-item">
        <span class="wechat-info-item-label">老师中心（菜单链接）</span>
        <div class="wechat-info-item-text">
          <div>微信公众号“自定义菜单”使用</div>
        </div>
        <el-input
          v-model="wechatInfo.teacher_url"
          type="textarea"
          resize="none"
          :autosize="{ minRows: 5 }"
        />
      </div>
      <div class="wechat-info-item">
        <span class="wechat-info-item-label">小班课中心（菜单链接）</span>
        <div class="wechat-info-item-text">
          <div>微信公众号“自定义菜单”使用</div>
        </div>
        <el-input
          v-model="wechatInfo.weekend_url"
          type="textarea"
          resize="none"
          :autosize="{ minRows: 5 }"
        />
      </div>
    </div>
    <div v-else class="wechat-setting-step-content">
      <div class="wechat-setting-step-title">
        <span :class="{ active: step == 1 }">1、填写信息</span>
        <b />
        <span :class="{ active: step == 2 }">2、进行授权</span>
      </div>
      <div v-if="step == 1" class="wechat-setting-step wechat-setting-step-one">
        <el-form ref="form" :model="wechatInfo" label-width="220px">
          <el-form-item label="开发者ID（App ID）" required>
            <el-input
              v-model="wechatInfo.authorizer_appid"
              clearable
              placeholder="请输入开发者ID"
            />
            <div class="wechat-setting-text">
              在微信公众平台，选择开发->基本配置->开发者ID(AppID)
            </div>
          </el-form-item>
          <el-form-item label="开发者密码（AppSecret）" required>
            <el-input
              v-model="wechatInfo.authorizer_secret"
              clearable
              placeholder="请输入开发者密码"
            />
            <div class="wechat-setting-text">
              在微信公众平台，选择开发->基本配置->开发者密码（AppSecret）->启用
            </div>
          </el-form-item>
          <el-form-item label="公众号唯一ID（原始ID）" required>
            <el-input
              v-model="wechatInfo.official_id"
              clearable
              placeholder="请输入公众号唯一ID"
            />
            <div class="wechat-setting-text">
              在服务号，选择头像->账号详情->注册信息->原始ID
            </div>
          </el-form-item>
          <el-form-item class="form-buttom">
            <el-button
              type="primary"
              class="el-button-confirm"
              @click="wechatSet(2)"
            >下一步</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="step == 2" class="wechat-setting-step wechat-setting-step-two">
        <a :href="wechatInfo.auth_url">点击授权</a>
        <div class="wechat-setting-ewm">
          <p v-if="flag">授权完成</p>
        </div>
        <div class="wechat-setting-btn">
          <el-button
            type="info"
            class="el-button-confirm"
            @click="step = 1"
          >上一步</el-button>
          <el-button
            type="primary"
            class="el-button-confirm"
            @click="getWechatInfo"
          >完成</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WechatSetting',
  components: {},
  data() {
    return {
      wechatInfo: {
        authorizer_appid: '',
        authorizer_secret: '',
        official_id: ''
      },
      copyUrl: '',
      step: 1,
      flag: false
    }
  },
  mounted() {
    this.getWechatInfo()
  },
  methods: {
    getWechatInfo() {
      this.$http.getWechatInfo().then(res => {
        if (res.data) {
          this.wechatInfo = res.data
          this.wechatInfo.auth_url =
            'http://third.tuolele.cn/api.php/WechatSet/jump?url=' +
            this.wechatInfo.auth_url
        }
        if (this.wechatInfo.status == '2') {
          this.flag = true
        }
      })
    },
    wechatSet(val) {
      if (
        !this.wechatInfo.authorizer_appid ||
        !this.wechatInfo.authorizer_secret ||
        !this.wechatInfo.official_id
      ) {
        this.$message({
          type: 'info',
          message: '请完善微信配置信息'
        })
        return
      }
      this.$http.wechatSet(this.wechatInfo).then(res => {
        if (res.code == 200) {
          this.step = val
        }
      })
    },
    setMessage() {
      this.$http.setIndustryAndTemplate().then(res => {
        if (res.code == 200) {
          this.copyUrl = res.data.url
          const input = document.getElementById('input')
          input.select()
          document.execCommand('copy')
          alert('复制成功')
        }
      })
    }
  }
}
</script>
<style lang="scss">
.wechat-setting {
  .wechat-setting-title span.color-blue {
    margin: 0 20px;
  }
  .wechat-info {
    margin-top: 60px;
    .wechat-info-item {
      margin-bottom: 20px;
      span.wechat-info-item-label {
        width: 200px;
        vertical-align: top;
        text-align: right;
        color: #333;
        margin-right: 20px;
      }
      .wechat-info-item-text {
        display: inline-block;
        width: 470px;
        div {
          color: #333;
          margin-bottom: 8px;
        }
        p {
          width: 470px;
          word-break: break-all;
          font-size: 14px;
        }
      }
    }
  }
  .el-textarea {
    display: block;
    width: 500px;
    margin-left: 220px;
  }
  #input {
    opacity: 0;
  }
  .wechat-setting-ewm {
    color: #4c84ff;
    margin-top: 20px;
  }
  .wechat-setting-step-content {
    width: 940px;
    margin: 50px auto;
    .wechat-setting-step-title {
      font-size: 24px;
      text-align: center;
      span.active {
        color: #333;
      }
      b {
        display: inline-block;
        width: 151px;
        margin: 12px 30px 0;
        vertical-align: top;
        border: solid 1px #d9d9d9;
      }
    }
    .wechat-setting-step {
      margin-top: 70px;
      a {
        width: 140px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #fff;
        background-color: #4c84ff;
        border-radius: 6px;
      }
      .el-input {
        width: 310px;
      }
      .wechat-setting-text {
        margin-left: 10px;
      }
      .form-buttom {
        border: none;
        margin-left: 100px;
      }
      .el-button {
        width: 140px !important;
      }
    }
    .wechat-setting-step-two {
      text-align: center;
      img {
        width: 180px;
        height: 180px;
        margin: 70px 0 10px;
      }
      .wechat-setting-btn .el-button {
        margin: 50px 30px;
      }
    }
    .wechat-setting-message {
      width: 790px;
      height: 100px;
      padding: 20px;
      margin: 60px auto 20px;
      border-radius: 6px;
      word-break: break-all;
      border: solid 1px #ebebeb;
    }
  }
}
</style>
